window.dataLayer = window.dataLayer || [];

export function setProductViewed(sku, productPrice) {
   window.dataLayer.push({
      google_tag_params: {
         ecomm_prodid: sku,
         ecomm_pagetype: 'product',
         ecomm_totalvalue: productPrice,
      },
   });
}
